import { render, staticRenderFns } from "./TextRightIcon.vue?vue&type=template&id=71e0db64&"
import script from "./TextRightIcon.vue?vue&type=script&lang=js&"
export * from "./TextRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports